function toggleCloseModal() {
    const modal = document.querySelector('#closeModal');
    if (!modal) return;
    Magellan.Modal.open(modal);
}


function callCloseModal() {
    const referrer = document.referrer;

    toggleCloseModal();

    const closeFormButton = document.querySelector('#closeForm');

    if (closeFormButton) {
        const homeUrl = themeDisplay.getPublicSiteDefaultURL() + '/home';
        const setHref = (referrer) => {
            if (referrer) {
                return new URL(referrer).toString();
            } else {
                return new URL(homeUrl).toString();
            }

        }

        closeFormButton.href = setHref(referrer);
    }

}

function addCloseModalListener() {
    // this is the main close button link for the theme
    const closeButton = document.querySelector('#closeButton');

    if (closeButton) {
        closeButton.addEventListener('click', (event) => {
            event.preventDefault();
            callCloseModal();
        })
    }
}

(function () {

    addCloseModalListener();

})();